export const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const NO_LEAD_TRAIL_SPACE_REQ_REGEX = /^(?!\s*$)\S+(?: \S+)*$/;
export const NO_LEAD_TRAIL_SPACE_OPT_REGEX = /^(?:\S+(?: \S+)*)?$/;
export const ALPHA_NUMERIC_AND_SPACE = /^[a-zA-Z0-9 ]*$/;
export const NUMERIC = /^[0-9]*$/;
export const ALPHA_NUMERIC_CHINESE_WITH_SOME_SPECIAL_CHAR_REGEX_OPT = /^[a-zA-Z0-9\u4e00-\u9fa5/&\-'_() ".\n]*$/;
export const ALPHA_NUMERIC_CHINESE_WITH_SOME_SPECIAL_CHAR_REGEX = /^[a-zA-Z0-9\u4e00-\u9fa5 /&\-'_()".\n]+[a-zA-Z0-9\u4e00-\u9fa5 /&\-'_()".\n]*$/;
export const MAX_LOADING_PERCENTAGE = 50;
